<div class="entity-lookup-dialog">
  <div class="dialog-header">
    <h2 class="dialog-title">Offices</h2>
    <button
      mat-icon-button
      class="close-button"
      tabindex="-1"
      aria-label="Close"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="entity-summary">
      <div class="entity-summary__identity">
        <span class="entity-summary__name">{{ data.userName }}</span>
        @if (!isLoading) {
          <span class="entity-summary__subtitle">{{ primaryName }}</span>
        }
      </div>
      @if (!isLoading) {
        <div class="entity-summary__stat">
          <span class="entity-summary__stat-label">Additional Offices</span>
          <span class="entity-summary__stat-value">{{ additionalCount }}</span>
        </div>
      }
    </div>

    @if (isLoading) {
      <div class="lookup-prompt">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
    } @else {
      <div class="lookup-section">
        @if (canManage) {
          <mat-form-field
            appearance="outline"
            class="lookup-search-field"
            subscriptSizing="dynamic"
          >
            <mat-label>Search offices</mat-label>
            <input
              matInput
              [(ngModel)]="searchQuery"
              (ngModelChange)="onSearchChange()"
              placeholder="Type to filter..."
              autocomplete="off"
            />
            <mat-icon
              matSuffix
              [style.cursor]="searchQuery ? 'pointer' : 'default'"
              (click)="clearSearch()"
              >{{ searchQuery ? "close" : "search" }}</mat-icon
            >
          </mat-form-field>
        }

        <div class="lookup-list">
          @let rows = displayRows;
          @if (rows.length === 0) {
            <div class="lookup-empty">
              <p>
                {{
                  searchQuery.trim()
                    ? "No matching offices"
                    : "No offices available"
                }}
              </p>
            </div>
          } @else {
            @for (row of rows; track row.code) {
              <div
                class="lookup-item"
                [class.is-add]="row.kind === 'available'"
                [class.is-remove]="row.kind === 'secondary' && canManage"
                [class.is-locked]="row.kind === 'primary'"
                [class.is-actionable]="
                  canManage && row.kind !== 'primary' && !isCodeLoading(row.code)
                "
                [class.is-loading]="isCodeLoading(row.code)"
                (click)="onRowClick(row)"
                [title]="
                  row.kind === 'available'
                    ? 'Click to add ' + row.name
                    : row.kind === 'secondary' && canManage
                      ? 'Click to remove ' + row.name
                      : ''
                "
              >
                <div class="item-info">
                  <span class="item-name">{{ row.name }}</span>
                  @if (row.meta) {
                    <span class="item-meta">{{ row.meta }}</span>
                  }
                </div>
                <div class="assigned-user-trailing">
                  @if (isCodeLoading(row.code)) {
                    <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
                  } @else if (row.kind === 'primary') {
                    <mat-icon
                      class="lock-icon"
                      matTooltip="This resource's primary office is sourced from the STB employee record, which is controlled outside of this application, so it cannot be removed."
                      matTooltipPosition="above"
                      >lock</mat-icon
                    >
                  } @else if (row.kind === 'secondary' && canManage) {
                    <mat-icon class="remove-icon">remove_circle</mat-icon>
                  } @else if (row.kind === 'available') {
                    <mat-icon class="add-icon">add_circle</mat-icon>
                  }
                </div>
              </div>
            }
          }
        </div>
      </div>
    }
  </mat-dialog-content>
</div>
